import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

interface IProps {
  /** based on the state, modal will be rendered */
  isOpen: boolean;

  /** JSX|String component */
  children: React.ReactNode | string;
}

export const BaseModal: React.FC<IProps> = ({ isOpen, children }) => {
  return (
    /* 
        Pass `isOpen` to the `open` prop, and use `onClose` to set
        the state back to `false` when the user clicks outside of the dialog or presses the escape key.
    */
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={() => null}>
        {/* Use one Transition.Child to apply one transition to the backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-100"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          {/* The backdrop, rendered as a fixed sibling to the panel container */}
          <div className="fixed inset-0 bg-white/30 z-40 backdrop-blur-md" />
        </Transition.Child>

        <Transition.Child
          as={Fragment}
          enter="ease-out duration-100"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {/* Full-screen container to center the panel */}
          <div className="fixed inset-0 flex items-center justify-center p-4 z-50">
            <Dialog.Panel className="w-full flex justify-center">{children}</Dialog.Panel>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};
